const labeli18n = {
    es: {
        formulario: {
            campo_obligatorio: '*',
        },
        app: {
            label: {
                mensaje_informativo: 'Mensaje informativo',
                mensaje_informativo_detalle: 'Detalle mensaje informativo',
            },
            acceso_restringido: 'Acceso Restringido',
            actualizar: 'Actualizar',
            agregar: 'Agregar',
            accion_control: 'Acción del control',
            afectacion_control: 'Afectación del control',
            aceptar: 'Aceptar',
            avance: 'Avance',
            archivo: 'Archivo',

            bienvenido: 'Bienvenid@',

            cancelar: 'Cancelar',
            catastro: 'Catastro',
            cambiar_sistema: 'Cambiar de Sistema',
            cambiar_organizacion: 'Cambiar de Organización',
            cambiar_password: 'Cambiar contraseña',
            campo_obligatorio: 'Campo obligatorio',
            correo: 'Correo electrónico',
            control_validacion: 'Control de validación',
            control: 'Control',
            condicion: 'Condición',
            comentario: 'Comentario',

            direccion: 'Dirección',
            detalle_justificacion: 'Detalle de la justificación',
            descripcion_error: 'Descripción del error',
            descargar: 'Descargar',
            documento: 'Documento',

            entidad: 'Entidad',
            exportar: 'Exportar',
            eliminar: 'Eliminar',
            estado: 'Estado',
            estado_solicitud: 'Estado de la solicitud',
            enviar: 'Enviar',
            estado_control: 'Estado del control',

            fecha_aplica_desde: 'Fecha aplica desde',
            fecha_aplica_hasta: 'Fecha aplica hasta',
            fecha_desde: 'Fecha desde',
            fecha_hasta: 'Fecha hasta',
            fecha_corte: 'Fecha de corte',
            fecha_corte_desde: 'Fecha de corte desde',
            fecha_corte_hasta: 'Fecha de corte hasta',
            fecha_solicitud: 'Fecha de solicitud',
            fecha_prorroga_hasta: 'Fecha de prórroga hasta',
            fusion_liquidacion: 'Fusión/Liquidación',
            frecuencia: 'Frecuencia',
            formula_cuenta: 'Fórmula o cuenta',
            fecha: 'Fecha',

            guardar: 'Guardar',
            grupo_estructura: 'Grupo de estructura',

            ingresar: 'Ingresar',
            identificacion_analista: 'Identificación analista',
            intento_carga: 'Intento de carga',
            ir_solicitud: 'Ir solicitud',

            justificacion: 'Justificación',
            justificacion_reproceso: 'Justificación del reproceso',

            maximo_apermitido: 'Máximo permitido',
            motivo_elimina: 'Motivo eliminación',
            mensaje_validacion: 'Mensaje de validación',
            modulo: 'Módulo',

            nuevo: 'Nuevo',
            num_dias_prorroga: 'Número de días de prórroga',
            numero_maximo: 'Número máximo permitido',
            nombre_analista: 'Nombre del analista',
            n_solicitud: 'N° Solicitud',
            nombre_control: 'Nombre del control',
            nombre_documento: 'Nombre del documento',
            nombre: 'Nombre',
            nombre_criterio: 'Nombre del criterio',
            no_cumple: 'No cumple',
            necesita_umbral: 'Necesita umbral',

            organizaciones_asignadas: 'Organizaciones Asignadas',
            observacion: 'Observación',
            opciones: 'Opciones',
            organizacion: 'Organización',

            password: 'Contraseña',

            reestrablecer_password: 'Reestablecer contraseña',
            razon_social: 'Razón social',
            ruc: 'RUC',
            reporta_como: 'Reporta como',
            regresar: 'Regresar',

            seleccion_sistema: 'Sistemas Disponibles',
            supervision_control: 'Supervisión y Control',
            seleccione_organizaciones_asignadas: 'Seleccion de organizaciones asociadas',
            segmento: 'Segmento',
            segmento_homologado: 'Segmento homologado',
            seleccione: 'Seleccione...',
            solicitud: 'Solicitud',

            tipo_control: 'Tipo de control',
            tipo_estructura: 'Tipo de estructura',
            tipo_umbral: 'Tipo umbral',
            telefono: 'Teléfono',
            tecnologicamente_administrable: 'Tecnológicamente administrable',

            usuario: 'Usuario',
            umbral: 'Umbral',

            valor_umbral: 'Valor umbral',

            //labels para bandeja consulta
            estado_juridico: 'Estado Jurídico',
            fecha_creacion: 'Fecha creación',
            fecha_finalizacion: 'Fecha finalización',
            acciones: 'Acciones',
            ver_detalle: 'Ver detalle',
            representante_legal: 'Representante legal',
            secretario: 'Secretario',
            codigo_seguridad: "Código de seguridad",
            estado_interno: 'Estado interno',
            estado_externo: 'Estado externo'

        },
        date: {
            long: 'MMMM Do, YYYY'
        },
        export: 'Export %{count} items',
        export_0: 'Nothing to export',
        export_1: 'Export %{count} item',
        two_lines: 'Line 1<br />Line 2',
        literal_two_lines: 'Line 1 / Line 2'
    },
    nl: {
        application: {
            title: 'Toffe app met i18n!',
            hello: 'Hallo, %{name}!'
        },
        date: {
            long: 'D MMMM YYYY'
        },
        export: 'Exporteer %{count} dingen',
        export_0: 'Niks te exporteren',
        export_1: 'Exporteer %{count} ding',
        two_lines: 'Regel 1<br />Regel 2',
        literal_two_lines: 'Regel 1 Regel 2'
    }
};

export default labeli18n;